/**
 * Enkel global auth-state utan extern state-lib.
 * Använder en singleton-pattern med React Context.
 * I framtida iteration: ersätt med Zustand om state-behoven växer.
 */

type AdminUser = {
  id: number;
  name: string;
  email: string;
  role: string;
};

type AuthState = {
  user: AdminUser | null;
  isAuthenticated: boolean;
};

type Listener = () => void;

class AuthStore {
  private state: AuthState = {
    user: null,
    isAuthenticated: false,
  };

  private listeners: Set<Listener> = new Set();

  getState(): AuthState {
    return this.state;
  }

  setUser(user: AdminUser | null): void {
    this.state = {
      user,
      isAuthenticated: user !== null,
    };
    this.notify();
  }

  logout(): void {
    this.setUser(null);
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  private notify(): void {
    this.listeners.forEach((l) => l());
  }
}

export const authStore = new AuthStore();

// React hook
import { useSyncExternalStore } from 'react';

export function useAuthStore<T>(selector: (state: AuthState) => T): T {
  return useSyncExternalStore(
    (cb) => authStore.subscribe(cb),
    () => selector(authStore.getState()),
  );
}
